import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import ArabicRegular from "../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../../../../../src/assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";
import ArabicComponent from "../../../../../utils/ArabComponent/ArabicComponent";
import PageLayout from "./contractService/PageLayout";
import BankImage from "./assets/bank-image.png";
import VatImage from "./assets/vat-image.png";

export default function ContractService({ contractDetails }) {
  Font.register({
    family: "Arabic",
    src: ArabicRegular,
  });
  Font.register({
    family: "ArabicBold",
    src: ArabicBold,
  });

  const styles = StyleSheet.create({
    arabicText: {
      fontFamily: "Arabic",
      textAlign: "right",
      direction: "rtl",
      fontSize: 9,
      margin: 5,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      // textDecoration: "underline",
    },
    arabicTextBold: {
      fontFamily: "ArabicBold",
      textAlign: "right",
      direction: "rtl",
      fontSize: 9,
      margin: 5,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      // textDecoration: "underline",
    },
  });

  const currentDate = new Date();

  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1; // Month is zero-based, so we add 1
  const year = currentDate.getFullYear();

  const Page1Data = {
    contract_number: contractDetails?.contract?.contract_number,
    visa_provider: contractDetails?.visa_provider?.name,
    company_cr: contractDetails?.visa_provider?.company_registration,
    company_address: contractDetails?.visa_provider?.address,
    company_po_box: contractDetails?.visa_provider?.po_box,
    company_code: contractDetails?.visa_provider?.pincode,
    company_mobile: contractDetails?.visa_provider?.mobile,
    company_email: contractDetails?.visa_provider?.email,
    company_signing_authority:
      contractDetails?.visa_provider?.signing_authority_person_name,
    company_nationalIdentity:
      contractDetails?.visa_provider?.national_identification_number,
    client_name: contractDetails?.client?.name,
    client_cr: contractDetails?.client?.company_registration,
    client_address: contractDetails?.client?.address,
    client_po_box: contractDetails?.client?.po_box,
    client_code: contractDetails?.client?.pincode,
    client_mobile: contractDetails?.client?.mobile,
    client_email: contractDetails?.client?.email,
    client_signing_authority: contractDetails?.client?.authorized_person_name,
    client_nationalIdentity:
      contractDetails?.client?.national_identification_number,
    date_of_contract: contractDetails?.contract?.created_at.slice(0, 10),
    industry_mentioned: "<INDUSTRY TO BE MENTIONED>",
    contract_tenure: contractDetails?.contract?.tenure,
    start_date: contractDetails?.contract?.start_date,
    end_date: contractDetails?.contract?.end_date,
    first_party: contractDetails?.visa_provider?.name,
    second_party: contractDetails?.client?.name,
    bank_account: contractDetails?.visa_provider?.bank_account_number,
    bank_image: "",
    vat_number: "",
    vat_image: contractDetails?.visa_provider?.vat_number,
  };

  const tableData = [
    {
      col1: "Name",
      col2: contractDetails?.visa_provider?.signing_authority_person_name,
      col3: "Name",
      col4: contractDetails?.client?.authorized_person_name,
    },
    {
      col1: "Position",
      col2: contractDetails?.visa_provider
        ?.signing_authority_person_designation,
      col3: "Position",
      col4: contractDetails?.client?.authorized_person_designation,
    },
    { col1: "Signature", col2: "", col3: "Signature", col4: "", height: 120 },
  ];

  const Table3Data = [
    {
      english: {
        title: "Preamble:",
        description:
          "The First party, according to the licenses it holds and its technical, administrative and operational expertise, human resources, trained workers and equipment, which enable it to participate in the execution of works from all government and private agencies. The Second Party requires the presence of a Service provider and an implementer with such skills. Both parties agree to the terms and conditions mentioned in this contract:",
        sub: [],
      },
      arabic: {
        title: "تمهيـــــــــــــد",
        description:
          "الطرف الأول بموجب ما يحملة من تراخيص وما يملكة من الخبرات الفنية والأدارية والتشغيلية والموارد البشريه والعمالة المدربة والمعدات  ما يمكنـــة من تنفيذ او المشاركة فى انجاز الأعمال المؤكلة الية من كافة الجهات الحكومية والخاصة التى تتطلب وجود منفــــذ لدية مثل هذة الأمكانيات، لذا اجتمعت مصلحــــة الطرفيـــــن على التعاقد فيما بينهما لأنجاز العمل حسب الشروط والبنود الواردة فى هذا العقد .",
        sub: [],
      },
    },
    {
      english: {
        title:
          "The two parties agree to execute the work in accordance with the following contract terms:",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (1): Purpose of the Contract:",
                description: `The Second Party whose business is in the ${Page1Data?.industry_mentioned}, and they seek to have assistance of the First party to manage and partially operate divisions, branches of the Company of the Second party and participate in the execution of work for the Second Party with all technical, advisory & human capabilities of the First Party and the tools and equipment if required. This includes the provision of materials, equipment, workers and all that may be required by the Second Party. All work shall be in accordance with a policy statement from the Second Party and under guidance and supervision of the Second Party. The First Party undertakes to execute all works as mentioned in the Contract. The First Party is not allowed to use the Logo/ Trade names or trademark of the Second Party or the affiliated Companies, without prior approval of the Second Party.  This agreement does not authorize the first party to be a partner with profits, but rather a partner in accomplishing the daily business of the second party for a specified fee.`,
              },
              {
                title: "Article (2): Contract Documents:",
                sub_title:
                  "2.1. This Contract consists of the following documents:",
                lists: [
                  "Contract Agreement document.",
                  "Special conditions. (If Any)",
                  "General conditions.",
                  "Bill of quantities and price categories. (As per Annexure)",
                ],
              },
              {
                title: "",
                sub_title:
                  "2.2.  These documents shall constitute to be an integral part of the Contract. Each document thereof shall be deemed to be part of the contract where the above-mentioned documents interpret and complement each other.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.3. In the event of a conflict among the contract documents, the latest document shall supersede over the previous ones.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        title: "فقد اتفق الطرفان علي تنفيذ العمل",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (1): الغرض من العقد :",
                description: `حيث ان الطرف الثانى يعمل فى نشاط ${Page1Data?.industry_mentioned} ، ويرغب بمشاركة الطرف الأول لأنجاز اعمالة التشغيلية لمنشأته و بأدارة وتشغيــــل جزئــــي لأقسام وفروع بشركة الطرف الثانى والمشاركة فى أنجاز اعمال الطرف الثانى بكل أمكانيات الطرف الأول الفنية والأستشاريه والبشرية والمعدات والأدوات التى تلــــــــزم، وسوف يقوم الطرف الأول بتنفيذ اعمال الطرف الثانى حسب مواصفات ومتطلبات وطريقة عمل الطرف الثانى وبموظفى ومستخدمى الطرف الأول وتحت ادارة وتوجية الطرف الأول، ولا يكون الطرف الأول شريك للطرف الثانى بما يملك او بمنشأته،  وانما يكون فقط مشارك للطرف الثانى لأنجاز اعمال تخص الطرف الثانى بأجـــــر يدفع الى الطرف الأول حسب الأتفاق، ولا يكون الطرف الأول شريكا للطرف الثانى او وكيلا عنه او مفوضا عنه يتعهد الطرف الأول بتنفيذ كافة الأعمال المنصوص عليها في العقد . لا يُسمح للطرف الأول باستخدام الشعار / الأسماء التجارية أو العلامات التجارية للطرف الثاني أو الشركات التابعة ، دون موافقة مسبقة من الطرف الثاني. لا تجيز هذه الاتفاقية للطرف الأول أن يكون شريكًا في الأرباح ، بل هو شريك في إنجاز الأعمال اليومية للطرف الثاني مقابل رسوم محددة .`,
              },
              {
                title: "المادة (2): وثائق العقد :",
                sub_title: "يتكون هذا العقد من الوثائق التالية:2.1",
                lists: [
                  "- وثيقة اتفاقية العقد",
                  "  شروط خاصة (اذا اي)",
                  "شروط عامة",
                  " فاتورة الكميات وفئات الأسعار. (حسب الملحق)",
                  "إضافة. ( اذا  أي )",
                ],
              },
              {
                title: "",
                sub_title:
                  "2.2. يجب أن تشكل هذه المستندات جزءًا لا يتجزأ من العقد. تعتبر كل وثيقة منها جزءًا من العقد حيث تفسر المستندات المذكورة أعلاه وتكمل بعضها البعض .",
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.3. في حالة وجود تعارض بين مستندات العقد ، يجب أن يحل المستند الأخير محل المستندات السابقة .",
                lists: [],
              },
            ],
          },
        ],
      },
    },

    {
      english: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (3): Contract Term",
                description: `The term of this Contract is for ${Page1Data?.contract_tenure} Gregorian calendar months effective from ${Page1Data?.start_date} and the Contract will end on ${Page1Data?.end_date}.  This Contract shall be renewed automatically for another identical period, unless either Parties express its desire not to renew the Contract in writing by virtue of a notice to be submitted at least (60) days before the expiry of the Original or Renewed Contract period.`,
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (3): مدة العقد",
                description: `مدة هذا العقد ${Page1Data?.contract_tenure} ميلادية اعتبارًا من ${Page1Data?.start_date} وينتهي العقد في ${Page1Data?.end_date}. يتم  تجديد هذا العقد تلقائيًا لفترة مماثلة أخرى ، ما لم يصرح أي من الطرفين بذلك .`,
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (4): Contract Value",
                description:
                  "The Contract total value shall be as per the annexure against the performance of this contract in accordance with the conditions, specifications, plans, bills of quantities, price categories and other contract documents.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (4): قيمة العقد",
                description:
                  "جب أن تكون القيمة الإجمالية للعقد وفقًا للملحق مقابل أداء هذا العقد وفقًا للشروط والمواصفات والمخططات وجداول الكميات وفئات الأسعار ومستندات العقد الأخرى",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (5): Payment",
                description:
                  "The Second Party undertakes to pay the contract value in the manner and at the times specified in the contract against the performance and completion of the contracted works by the First Party.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (5): الدفع",
                description:
                  "يتعهد الطرف الثاني بدفع قيمة العقد بالطريقة وفي الأوقات المحددة في العقد مقابل أداء وإنجاز الأعمال المتعاقد عليها من قبل الطرف الأول .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (6): Contract Law",
                description:
                  "This Contract shall be governed; interpreted and performed in accordance with the laws in force in the Kingdom the litigation(s) arising out of it shall be resolved in accordance with the competent authorities.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (6): نظام العقود",
                description:
                  "نظام  هذا العقد ؛ يفسر وينفذ  وفقاً للأنظمة المعمول بها في المملكة ، ويُفصل في التقاضي أو الدعاوى الناشئة عنها وفقاً للجهات المختصة .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (7): Settlement of Disputes",
                description:
                  "Any dispute arising out of this contract and not settled by the parties, shall be referred to the competent judicial bodies in Kingdom of Saudi Arabia, the ruling of which shall be final. In Witness Whereof, the parties signed this document in the place and on the date above mentioned.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " لمادة (7): تسوية الخلافات",
                description:
                  "يحال أي نزاع ينشأ عن هذا العقد ولم يتم تسويته من قبل الأطراف إلى الجهات القضائية المختصة في المملكة العربية السعودية ، ويكون الحكم فيه نهائيًا .وإثباتًا لما تقدم ، وقع الطرفان على هذه الوثيقة في المكان وفي التاريخ المذكورين أعلاه ",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "General Conditions",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (8): Definitions:",
                description:
                  "The following words and expressions as used in this Contract and its Schedules shall have the meaning ascribed to them as below:",
                sub_title: "",
                lists: [
                  `a.  The First Party: ${Page1Data?.first_party} and its branches.`,
                  `b.  The Second Party: ${Page1Data?.second_party}`,
                  "c.  Work Representative: A person who is appointed at any time by any party to follow up the execution of works.",
                  "d.  Works: All permanent and temporary works and services to be executed under the contract.",
                  "e.  Operations: Daily execution of works for which the First Party is assigned this Contract.",
                  "f.  Equipment: Means machinery, tools and devices to be provided for use in the execution of works and service.",
                  "g.  Specifications: The special and general specifications and manuals for works or services referred to in this contract as well as any amendments or additions thereto with the consent of the Second Party.",
                  "h.  The Consent: The written consent, including subsequent written confirmations of any previous oral consent by either email or hard copy.",
                  "i.  Month: Means the Gregorian month.",
                ],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: " شروط عامة",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (8): التعريفات ",
                description:
                  "الكلمات والعبارات التالية كما هي مستخدمة في هذا العقد وجداوله يكون لها المعنى المنسوب لها على النحو التالي :",
                sub_title: "",
                lists: [
                  `أ- الطرف الأول: مجموعة ${Page1Data?.first_party} وفروعها`,
                  `ب- الطرف الثاني: ${[Page1Data?.second_party]}`,
                  `
ج- ممثل العمل: الشخص الذي يعين في أي وقت من قبل أي جهة لمتابعة تنفيذ الأعمال`,
                  "د- الأشغال: جميع الأعمال والخدمات الدائمة والمؤقتة التي سيتم تنفيذها بموجب العقد .",
                  "هـ- العمليات: التنفيذ اليومي للأعمال التي تم تكليف الطرف الأول بها في هذا العقد",
                  "و- المعدات: الآلات والأدوات والأجهزة الواجب توفيرها لاستعمالها في تنفيذ الأعمال والخدمات",
                  "ز. المواصفات: المواصفات والأدلة الخاصة والعامة للأعمال أو الخدمات المشار إليها في هذا العقد وأي تعديلات أو إضافات عليها بموافقة الطرف الثاني",
                  "ح- الموافقة: الموافقة الكتابية ، بما في ذلك التأكيدات الخطية اللاحقة لأي موافقة شفوية سابقة عن طريق البريد الإلكتروني أو نسخة ورقية",
                  "ط- الشهر: يستخدم الشهر الميلادي",
                ],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (9): First Party Representative",
                description:
                  "The duty of the First Party’s representative shall be to Supervise and control of works, managing and directing the employees of the First Party, all devices and equipment of the First Party, confirmation of the employees' requests, provision of all requirements of the project and employees, supervision of execution of all requests of the Second Party according to the directions and policies of the Second Party.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " مادة (9): ممثل الطرف الأول",
                description:
                  "جب أن يكون واجب ممثل الطرف الأول هو الإشراف والرقابة على الأعمال ، وإدارة وتوجيه موظفي الطرف الأول ، وجميع أجهزة ومعدات الطرف الأول ، وتأكيد طلبات الموظفين ، وتوفير جميع متطلبات المشروع و الموظفين ، والإشراف على التنفيذ لجميع  طلبات الطرف الثاني حسب توجيهات وسياسات الطرف الثاني",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (10): Subcontract",
                description:
                  "The First Party may not subcontract to execute all works and services of the contract, and it may not also – unless otherwise herein stated – subcontract with third parties to execute a part of works and services without the prior written consent of the Second Party.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (10): العقد من الباطن",
                description:
                  "لا يجوز للطرف الأول التعاقد من الباطن لتنفيذ جميع أعمال وخدمات العقد ، ولا يجوز له أيضًا - ما لم يُنص على خلاف ذلك في هذه الاتفاقية - التعاقد من الباطن مع أطراف ثالثة لتنفيذ جزء من الأعمال والخدمات دون موافقة خطية مسبقة من الطرف الثاني .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Contract Scope:",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (11): The Contract shall include:",
                description:
                  "The Second Party’s requirement for specific activities (Management and partial operation, maintenance, cleaning, Transportation, Loading & Unloading Contract, participation in all works of the Second Party).",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "نطاق العقد:",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (11): يجب أن يشتمل العقد على",
                description:
                  "متطلبات الطرف الثاني لأنشطة محددة (الإدارة والتشغيل الجزئي ، الصيانة ، التنظيف ، النقل ، عقد التحميل والتفريغ ، المشاركة في جميع أعمال الطرف الثاني) .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Contract Language:",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (12):",
                description:
                  "The Arabic language shall be the language adopted in the interpretation and performance of this contract. However, the parties may use a foreign language in writing the contract or part thereof beside Arabic. If there is a discrepancy between the Arabic and Foreign texts, the Arabic text shall prevail. With respect to specifications and plans, the approved language shall be Arabic.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "لغة العقد:",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (12):",
                description:
                  "اللغة العربية هي اللغة المعتمدة في تفسير وتنفيذ هذا العقد. ومع ذلك ، يجوز للطرفين استخدام لغة أجنبية في كتابة العقد أو جزء منه إلى جانب اللغة العربية. إذا كان هناك تناقض بين النصين العربي والأجنبي يعتمد  النص العربي. فيما يتعلق بالمواصفات والمخططات ، تكون اللغة المعتمدة هي اللغة العربية.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (13):",
                description:
                  "The parties undertake that the commercial registrations and licenses shall be valid, renewed before expiration, that each party shall provide the other party with a valid copy of the registrations and licenses and that all fees and taxes shall be paid in accordance with the applicable regulations.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة ( 13):",
                description:
                  "يتعهد الطرفان بأن تكون السجلات والتراخيص التجارية سارية المفعول ، وتجدد قبل انتهاء صلاحيتها ، وأن يقدم كل طرف للطرف الآخر نسخة صالحة من السجلات والتراخيص ، وأن يتم دفع جميع الرسوم والضرائب وفقًا للأنظمة المعمول بها.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (14): Additional Instructions:",
                description:
                  "The First Party shall secure work visit visas and commercial visit visas if the work so requires as the First Party has experience in bringing expert Consultants from outside the Kingdom according to the nature of the contract.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "مادة (14): تعليمات إضافية :",
                description:
                  "يقوم الطرف الأول بتأمين تأشيرة زيارة العمل وتأشيرة  زيارة الاعمال  إذا تطلب العمل ذلك حيث أن الطرف الأول لديه خبرة في جلب الخبراء الاستشاريين من خارج المملكة حسب طبيعة العقد .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "General Provisions",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (15): Guarantee",
                description:
                  "The Second Party shall provide a financial guarantee as mentioned in the Annexure as a guarantee to the First Party for providing its services. The same shall be refundable after the end of the contract.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: " الأحكام العامة",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (15): الضمان",
                description:
                  "يقدم الطرف الثاني ضمانًا ماليًا كما هو مذكور في الملحق كضمان للطرف الأول مقابل تقديم خدماته. يجب أن تكون قابلة للاسترداد بعد انتهاء العقد .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (16): Notices and Notifications:",
                description:
                  "Communication and notification between the parties shall be through e-mail or an official letter to be personally delivered. No verbal decision or instruction between the parties shall be accepted. The official e-mail and the official address are indicated at the beginning of the contract.  The two parties acknowledge that the addresses and data contained in this article are correct and legally binding.  In the event of a change in the address of one of the parties, the party that has changed its address must notify the other party of that change in writing as soon as the change occurs.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (16): الإشعارات والتنبيهات:",
                description:
                  " يجب أن يكون الاشعار والإخطار بين الطرفين عبر البريد الإلكتروني أو خطاب رسمي يتم تسليمه شخصيًا. لا قرار شفهي .يجب قبول التعليمات بين الطرفين. يشار إلى البريد الإلكتروني الرسمي والعنوان الرسمي في بداية العقد .يقر الطرفان بأن العناوين والبيانات الواردة في هذه المقالة صحيحة وملزمة قانونًا.في حالة حدوث تغيير في عنوان أحد الطرفين ، يجب على الطرف الذي قام بتغيير عنوانه إشعار الطرف الآخر بهذا التغيير كتابيًا بمجرد حدوث التغيير . ",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (17): Selection of Employees:",
                description:
                  "The First Party undertakes to provide human resources and trained workers to ensure that the work is executed as specified in the Annexure of the Contract. All the workers shall have valid residence permits & medical insurance. The First Party will also pay salaries and entitlements on time without delay, and will also ensure that all requirements are according to the applicable laws and regulations.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "مادة (17): اختيار الموظفين:",
                description:
                  "يتعهد الطرف الأول بتوفير الموارد البشرية والعمالة المدربة لضمان تنفيذ العمل على النحو المحدد في ملحق العقد. يجب أن يكون لدى جميع العمال تصاريح إقامة سارية المفعول وتأمين طبي. سيدفع الطرف الأول أيضًا الرواتب والمستحقات في الوقت المحدد دون تأخير ، وسيضمن أيضًا أن تكون جميع المتطلبات وفقًا للقوانين واللوائح المعمول بها .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (18): Schedule of Work: ",
                description:
                  "The First Party shall perform the works and services stated in the Contract. It shall abide by the instructions of the Second Party or its representative and its written directions in any subject relating to or connected with works and services of this Contract.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "مادة (18): جدول العمل: ",
                description:
                  "يقوم الطرف الأول بتنفيذ الأعمال والخدمات المنصوص عليها في العقد. يجب أن يلتزم بتعليمات الطرف الثاني أو ممثله وتوجيهاته المكتوبة في أي منها خاضعة أو مرتبطة بأعمال وخدمات هذا العقد .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (19) ",
                description: "",
                sub_title: "",
                lists: [
                  "19.1. The Second Party shall notify the First Party of any discrepancies in the Invoice submitted by the First Party within 7 working days of the submission of the same.  Failing which, the Invoice shall be considered as deemed approved for payment.",
                  "19.2. The Second Party undertake not to provide a work offer, partial work or any works of any nature to any employee of the First Party during the contract term.  In the event of doing so without the consent of the First Party, the fine shall be fifty thousand (50,000) riyals for each employee, Exceptions for Saudi employees only.  After two (2) years of the contract expiration, Second Party can provide work offer to First Party employee who completed 2 years of contract, First Party shall approve the Transfer.",
                  "19.3. Pre matured termination of Contract is considered as a violation of the terms of agreement that obliges Second Party to bear the extra financial obligations in accordance with the Contract period as follows,",
                  "19.4. If SECOND PARTY does not complete the 24 Gregorian month's period, SECOND PARTY shall be liable to pay actual expenses of all Government Id’s, (work permit, Iqama, Baladiya, Insurance, Visa, recruitment cost, processing charges etc.) in addition to fifty percent (50%) of FIRST PARTY remaining works for the remaining agreement period and actual return air fare as penalty.  This exempts for Non-Return Exit Re-Entry and Abscond/run-away cases.",
                  "19.5. This Contract shall be renewed automatically for another identical period, unless either Parties express its desire not to renew the Contract in writing by virtue of a notice to be submitted at least (60) days before the expiry of the Original or Renewed Contract period.  It also undertakes to facilitate the access to the project site by any third party during the notice period.The parties have agreed that the First Party shall be entitled to dismantle and transport its belongings from the site after the termination notice period. The Second Party also undertakes to clear the Invoices and expenses of the First Party within 7 days of the notice of Termination.",
                ],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " لمادة(19)",
                description: "",
                sub_title: "",
                lists: [
                  "1.19. يجب على الطرف الثاني إشعار الطرف الأول بأي تناقضات في الفاتورة المقدمة من الطرف الأول في غضون 7 أيام عمل من تاريخ تقديمه. في حال عدم حدوث ذلك ، تعتبر الفاتورة على أنها تمت الموافقة على الدفع .",
                  "2.19. يتعهد الطرف الثاني بعدم تقديم عرض عمل أو عمل جزئي أو أي أعمال من أي نوع كانت لأي موظف لدى الطرف الأول خلال مدة العقد. وفي حال القيام بذلك دون موافقة الطرف الأول ، تكون الغرامة خمسين ألف (50،000) ريال سعودي  عن كل موظف ، ويستثنى من ذلك الموظفين السعوديين فقط. بعد عامين (2) من انتهاء صلاحية العقد ، يمكن للطرف الثاني تقديم عرض عمل لموظف الطرف الأول الذي أكمل عامين من العقد ، ويوافق الطرف الأول على النقل .",
                  "3.19. يعتبر إنهاء العقد قبل موعد استحقاقه بمثابة انتهاك لشروط الاتفاقية التي تالطرف الثاني بتحمل الالتزامات المالية الإضافية وفقًا لفترة العقد على النحو التالي",
                  "4.19. إذا لم يكمل الطرف الثاني فترة 24 شهرًا ميلاديًا ، فسيكون الطرف الثاني مسؤولاً عن دفع النفقات الفعلية لجميع بطاقات الهوية الحكومية (تصريح العمل ، الإقامة ، البلدية ، التأمين ، التأشيرات ، تكاليف التوظيف ، رسوم المعالجة وما إلى ذلك) بالإضافة إلى خمسين. في المائة (50٪) من الأعمال المتبقية للطرف الأول للفترة المتبقية من الاتفاقية وأجرة العودة الفعلية كعقوبة. هذا يستثني من حالات ذهب ولم يعد  , خروج وعودة والهروب / حالات الهروب .",
                  "5.19. يجب تجديد هذا العقد تلقائيًا لفترة مماثلة أخرى ، ما لم يوضح أي من الطرفين عن رغبته في عدم تجديد العقد كتابيًا بموجب إشعار يتم تقديمه قبلها بـ (60) يومًا على الأقل من انتهاء فترة العقد الأصلي أو المجدد. كما تتعهد بتسهيل وصول أي طرف ثالث إلى موقع المشروع خلال فترة الإشعار . ",
                  "اتفق الطرفان على أنه يحق للطرف الأول تفكيك ونقل ممتلكاته من الموقع بعد فترة إشعار الإنهاء. يتعهد الطرف الثاني أيضًا بمسح فواتير ونفقات الطرف الأول في غضون 7 أيام من إشعار الإنهاء .",
                ],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (20): Schedule of Work",
                description:
                  "The First Party shall submit to the Second Party detailed information relating to the schedule required to achieve the works and services to be performed by the First Party in accordance with the contract documents.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (20): جدول العمل",
                description:
                  "يجب على الطرف الأول أن يقدم للطرف الثاني معلومات مفصلة تتعلق بالجدول الزمني المطلوب لإنجاز الأعمال والخدمات التي سيقوم بها الطرف الأول وفقاً لوثائق العقد  . ",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (21): Supervision by the First Party:",
                description:
                  "The First Party shall carry out the necessary supervision during the performance of the contract to the extent deemed necessary by the First Party to fulfill its contractual obligations properly. The First Party shall appoint a representative or Supervisor who shall provide the necessary supervision and support for smooth execution of the work.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (21) إشراف الطرف الأول: ",
                description:
                  "يقوم الطرف الأول بالإشراف اللازم أثناء تنفيذ العقد بالقدر الذي يراه الطرف الأول ضروريًا للوفاء بالتزاماته التعاقدية بشكل صحيح. يعين الطرف الأول ممثلاً أو مشرفًا يتولى الإشراف والدعم اللازمين للتنفيذ السلاسة  للعمل .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (21): Supervision by the First Party:",
                description: "",
                sub_title:
                  "22.1. The First Party shall provide the following for the execution of the work and services:",
                lists: [
                  "a.  Skilled and Unskilled workers with Supervisors to properly supervise work assigned as per the Annex.",
                  "b.  The required quantity of skilled and semi-skilled workers to execute and complete the work properly.",
                ],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "22.2. Both parties together shall be entitled, in all cases, to request the First Party to immediately exclude from the work site any person employed by the First Party, in the execution of the works and services or in any matter relating thereto if they deem it of bad behavior, non-competent, negligent in its duties. The First Party shall replace, as soon as possible, any person excluded as indicated above with a competent alternative.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title:
                  " المادة  (22) : الأفراد الذين تم نشرهم من قبل الطرف الأول",
                description: "",
                sub_title: " 1.22. يلتزم الطرف الأول بتنفيذ الأعمال والخدمات",
                lists: [
                  "أ) العمالة الماهرة  وغير الماهرة  يكونوا مع مشرفين للإشراف بشكل صحيح على الأعمال المخصصة وفقًا للملحق .",
                  "ب) الكمية المطلوبة من العمالة الماهرة ونصف الماهرة لتنفيذ وانجاز العمل بشكل صحيح . ",
                ],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.22. يحق للطرفين معًا ، في جميع الأحوال ، أن يطلبوا من الطرف الأول أن يستبعد على الفور من موقع العمل أي شخص يعمل لدى الطرف الأول ، في تنفيذ الأعمال والخدمات أو في أي مسألة تتعلق بها إذا رأوا أنه سلوك سيء ، غير كفء ، تقصير في واجباته. يستبدل الطرف الأول ، في أقرب وقت ممكن ، أي شخص مستبعد كما هو مذكور أعلاه ببديل مختص .",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (23): Assigning Tasks out of the Contract",
                description:
                  "The Second Party shall not assign tasks or deliver funds or valuables to any of the employee of the First Party. The Second party shall be fully responsible for the losses in case of any assault, theft, misappropriation, loss or any kind of losses. In case of desire and need to do so, the Second Party shall be do the same through a separate agreement and a separate annex to this contract.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (23): تكليف المهام خارج نطاق العقد",
                description:
                  "لا يجوز للطرف الثاني تكليف أي من موظفي الطرف الأول بمهام أو تسليم أموال أو أشياء ثمينة. يتحمل الطرف الثاني المسؤولية الكاملة عن الخسائر في حالة حدوث أي اعتداء أو سرقة أو اختلاس أو خسارة أو أي نوع من الخسائر. في حالة الرغبة والحاجة لذلك ، يجب على الطرف الثاني أن يفعل الشيء نفسه من خلال اتفاقية منفصلة وملحق منفصل لهذا العقد .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title:
                  "Article (24): Serving Notices and Payment of Fees and Fines:",
                description: "",
                sub_title:
                  "24.1. Both parties shall undertake to pay all fees prescribed under the laws, regulations or decisions in relation to the execution of works and services or in relation to the rules and regulations, in any form.",
                lists: [],
              },
              {
                title: "24.2. Compliance with Laws and Decisions:",
                description:
                  "All parties shall comply with the laws, regulations and decisions issued by the general competent authority relating to works and services as well as comply with the laws and rules of the public bodies and the relevant companies will bear the responsibility and the prescribed fines of whatever kind due to violation of such laws, regulations and decisions.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (24): تقديم الإشعارات ودفع الرسوم والغرامات : ",
                description: "",
                sub_title:
                  "1.24.يلتزم الطرفان بدفع جميع الرسوم المقررة بموجب القوانين أو اللوائح أو القرارات المتعلقة بتنفيذ الأعمال والخدمات أو فيما يتعلق بالقواعد واللوائح بأي شكل من الأشكال .",
                lists: [],
              },
              {
                title: "الامتثال للقوانين والقرارات:2.24",
                description:
                  "يلتزم جميع الأطراف بالقوانين والأنظمة والقرارات الصادرة عن الجهة  المختصة العامة المتعلقة بالأعمال والخدمات وكذلك الامتثال لقوانين وقواعد الهيئات العامة وتتحمل الشركات ذات الصلة المسؤولية والغرامات المقررة مهما كان نوعها. بسبب انتهاك هذه القوانين والأنظمة والقرارات .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (25): Employees and Workers:",
                description:
                  "The First Party shall make special arrangements to recruit and employ all workers, (nationals or expat workers). The First Party shall make necessary arrangements for national or International recruitment, necessary Govt. approvals, deployment formalities, medical checkup, and necessary process to be followed as per KSA Labor Law, etc. The First Party also undertakes to provide the worker basic needs required for its workers including, housing, transportation, health Insurance, Kitchen facility etc. in accordance with the special conditions.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " لمادة (25) الموظفون والعمال",
                description:
                  "يتخذ الطرف الأول ترتيبات خاصة لتوظيف وتشغيل جميع العمال (مواطنين أو عمال وافدين). يتخذ الطرف الأول الترتيبات اللازمة للتوظيف الوطني أو الدولي ، والحكومي الضروري. الموافقات ، وإجراءات النشر ، والفحص الطبي ، والاعمال  اللازمة التي يجب اتباعها وفقًا لقانون العمل السعودي ، وما إلى ذلك. كما يتعهد الطرف الأول أيضًا بتزويد العامل بالاحتياجات الأساسية المطلوبة لعماله بما في ذلك السكن ، والنقل ، والتأمين الصحي ، ومرافق المطبخ ، إلخ. وفق الشروط الخاصة. ",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (26): Statements of Workers",
                description:
                  "The First Party shall provide, on the times determined by the Second Party or its representative, a detailed statement indicating the names of all employees, workers, their salaries and other information that may be required by the Second Party.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " لمادة (26): كشوفات العمال",
                description:
                  "يقدم الطرف الأول ، في المواعيد التي يحددها الطرف الثاني أو من ينوب عنه ، بيانًا تفصيليًا يوضح أسماء جميع الموظفين والعاملين ورواتبهم والمعلومات الأخرى التي قد يطلبها الطرف الثاني .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (27): Rate of Work Progress:",
                description:
                  "The First Party shall regularly submit to the Second Party, as reflected in the special conditions, detailed reports on the materials, workers and work progress.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "لمادة (27): معدل تقدم العمل: ",
                description:
                  "يقدم الطرف الأول بانتظام للطرف الثاني ، على النحو المبين في الظروف الخاصة ، تقارير مفصلة عن المواد والعمال وسير العمل .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title:
                  "Article (28): Costs of Carrying out Works, Repair and other:",
                description:
                  "If the works of this contract requires purchase of spare parts required for the works of operation and maintenance, such works shall be executed by the Second Party.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "  لمادة (28) : تكاليف تنفيذ الأعمال والإصلاح وغيرها",
                description:
                  "إذا كانت الأعمال الواردة في هذا العقد تتطلب شراء قطع الغيار اللازمة لأعمال التشغيل والصيانة ، يتولى الطرف الثاني تنفيذ هذه الأعمال .",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (29): Amendments, Additions and Cancellations",
                description: "",
                sub_title:
                  "29.1. The Second Party shall be entitled to make any change in the form, type or quantity of works and services or any part thereof as it deems fit. The First Party shall implement the same provided that this shall not lead to a change in the subject matter of the contract or exceeding the limits provided in the clause 29.2 & 29.03 of this Contract.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "29.2. The Second Party, employer, may- during the contract performance- increase the amount of works & services, and it shall be at an additional cost.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "29.3. The Second Party shall only carry out any of the changes indicated with a written order from the Second Party, or its representative to the First Party.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (29): التعديلات والإضافات والإلغاءات",
                description: "",
                sub_title:
                  "1.29. يحق للطرف الثاني إجراء أي تغيير في شكل أو نوع أو كمية الأعمال والخدمات أو أي جزء منها يراه مناسباً. يجب على الطرف الأول تنفيذ نفس الشيء المتاح ألا يؤدي ذلك إلى تغيير في موضوع العقد أو تجاوز الحدود المنصوص عليها في الفقرة 29.2 و 29.03 من هذا العقد .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.29. يجوز للطرف الثاني صاحب العمل - أثناء تنفيذ العقد - زيادة كمية الأعمال والخدمات ، ويكون ذلك بتكلفة إضافية .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "3.29. يقوم الطرف الثاني فقط بتنفيذ أي من التغييرات المشار إليها بأمر كتابي من الطرف الثاني أو ممثله لدى الطرف الأول .",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (30): Changes:",
                description: "",
                sub_title:
                  "30.1. The Second Party shall determine the value- if any- it considers to be added to or deducted from the amount mentioned in the offer due to excess or additional work executed or cancelled based on its order. The evaluation shall be made before the commencement of the additional work in accordance with the items mentioned in the contract. If the contract does not include any similar items applying to the additional work, the Second Party, and the First Party shall agree on the determination of the fair prices thereof.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "30.2. The First Party shall send to the Second Party statement of Account explaining fully and in detail the information of all claims relating to the additional expenses the First Party considers that it has right thereto and to all additional works ordered by the Second Party, and executed by the First Party during the previous month.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: " المادة (30): التغييرات",
                description: "",
                sub_title:
                  "1.30. يحدد الطرف الثاني القيمة - إن وجدت - التي يرى أنها تضاف إلى أو تخصم من المبلغ المذكور في العرض بسبب زيادة أو عمل إضافي تم تنفيذه أو إلغاؤه بناءً على طلبه. يتم التقييم قبل الشروع في العمل الإضافي وفق البنود الواردة في العقد. إذا لم يتضمن العقد أي بنود مماثلة تنطبق على العمل الإضافي ، يتفق الطرف الثاني والطرف الأول على تحديد الأسعار العادلة لها .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.30. يرسل الطرف الأول إلى الطرف الثاني كشف حساب يشرح بشكل كامل ومفصل معلومات جميع المطالبات المتعلقة بالمصروفات الإضافية التي يعتبرها الطرف الأول أن له الحق فيها وجميع الأعمال الإضافية التي أمر بها الطرف الثاني ، ويتم تنفيذها من قبل الطرف الأول خلال الشهر السابق .",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (31): Equipment, Temporary Works and Materials",
                description: "",
                sub_title:
                  "31.1. Use of Equipment, Materials and Other Works: The equipment and materials provided by the First Party – after being brought to the site- shall be deemed to be fully dedicated to maintenance, operation and cleaning to achieve the common work.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "31.2. Transport of equipment, materials and others: After completion of works, the First Party shall transport from the site all mentioned remaining equipment and all non-used materials brought by it.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "31.3. Non-Responsibility of the Second Party for a failure in the equipment and others: The Second Party shall not be responsible, at any time, for any loss or damage to any of the equipment or materials.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (31) : المعدات والأشغال المؤقتة والمواد",
                description: "",
                sub_title:
                  "1.31 . استخدام المعدات والمواد وغيرها العمل: تعتبر المعدات والمواد التي يوفرها الطرف الأول - بعد إحضارها إلى الموقع - مكرسة بالكامل للصيانة والتشغيل والتنظيف لتحقيق العمل المشترك  . ",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  ". نقل المعدات والمواد وغيرها:2.31 بعد الانتهاء من الأعمال يقوم الطرف الأول بنقل جميع المعدات المتبقية المذكورة وجميع المواد غير المستعملة التي جلبها من الموقع .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "عدم مسؤولية الطرف الثاني عن عطل في المعدات والغير:3.31.لن يكون الطرف الثاني مسؤولاً ، في أي وقت ، عن أي خسارة أو ضرر يلحق بأي من المعدات أو المواد",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "Article (32):",
            description: "32.1. Method of Payment",
            articles: [
              {
                title: "",
                description:
                  "The Invoices of the First Party shall be paid according to the completed work / Bill of quantity / Invoices approved by the Second Party, periodically each month.",
                sub_title: "",
                lists: [],
              },
              {
                title: "32.2 Payment",
                description:
                  "Subject to regulations and instructions, all payments shall be in Saudi Riyals unless another currency is provided for in the special conditions.",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "32)المادة",
            description: "1.32. طريقة الدفع",
            articles: [
              {
                title: "",
                description:
                  "يتم دفع فواتير الطرف الأول وفقًا للعمل المنجز / فاتورة الكمية / الفواتير المعتمدة من قبل الطرف الثاني ، بشكل دوري كل شهر .",
                sub_title: "",
                lists: [],
              },
              {
                title: "2.32 الدفع",
                description:
                  "مع مراعاة الأنظمة والتعليمات ، تكون جميع المدفوعات بالريال السعودي ما لم يتم النص على عملة أخرى في الشروط الخاصة",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "Article (33): Invoice payment Transfers:",
            description:
              "The payment due to the First Party shall be transferred to the following bank account:",
            account_number: `${Page1Data?.bank_account}`,
            bank_image: "",
            vat_number: `${Page1Data?.vat_number}`,
            vat_image: "",
            articles: [],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "المادة (33) تحويلات سداد الفواتير",
            description:
              "يتم تحويل الدفعة المستحقة للطرف الأول إلى الحساب المصرفي التالي",
            account_number: `${Page1Data?.bank_account}`,
            bank_image: `${Page1Data?.bank_image}`,
            vat_number: `${Page1Data?.vat_number}`,
            vat_image: `${Page1Data?.vat_image}`,
            articles: [],
          },
        ],
      },
    },

    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (34): Withdrawal of Work:",
                description:
                  "Without prejudice to other relevant regulation, the Second Party may withdraw the work from the First Party in any of the following cases:",
                sub_title:
                  "34.1. If the First Party delays in commencing the work, shows underperformance, slowness in its progress with no compelling or persuasive reason for delay.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "34.2. In case the First Party withdraws from, abandons or give up work or subcontracts for its execution without prior permission from the Second Party.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "34.3. If the First Party violates any of the conditions of the contract or refrains from the execution of any of its contractual obligations and fails to correct within the stipulated timeframe expiration of the Contract.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "34.4. If the First Party goes bankrupt, request the declaration of its bankruptcy, its insolvency is established or an order is issued to be placed under guard. The withdrawal of work from the First Party shall be through a written notice without need to take any judicial procedures or other. The Clause 34 (1) to (4) shall become applicable only after the Second Party has given necessary notice & warning to the First Party with appropriate time frame for rectification. In case the Second Party withdraws the work assigned to the First Party, the Second Party will still be liable to pay all outstanding dues to the First Party till the date of withdrawal of works from the First Party.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (34): سحب العمل :",
                description:
                  "مع عدم الإخلال بالأنظمة الأخرى ذات الصلة ، يجوز للطرف الثاني سحب العمل من الطرف الأول في أي من الحالات التالية :",
                sub_title:
                  "1.34.إذا تأخر الطرف الأول في بدء العمل ، وأظهر أداء ضعيفًا ، وبطءًا في تقدمه دون سبب مقنع أو مقنع للتأخير .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.34. في حالة انسحاب الطرف الأول أو تخليه  عن العمل أو التعاقد من الباطن لتنفيذه دون إذن مسبق من الطرف الثاني .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "3.34. إذا خالف الطرف الأول أيًا من شروط العقد أو امتنع عن تنفيذ أي من التزاماته التعاقدية وفشل في التصحيح خلال الإطار الزمني المحدد لانتهاء العقد",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "4.34. إذا أفلس الطرف الأول ، تم إعلان إفلاسه أو ثبوت إفلاسه أو إصدار أمر بوضعه تحت الحراسة. يكون انسحاب العمل من الطرف الأول بإشعار كتابي دون الحاجة إلى اتخاذ أي إجراءات قضائية أو غيرها. تصبح البنود 34 (1) إلى (4) قابلة للتطبيق فقط بعد أن يقدم الطرف الثاني الإشعار والتحذير الضروريين للطرف الأول مع إطار زمني مناسب للتصحيح. في حالة قيام الطرف الثاني بسحب العمل المخصص للطرف الأول ، يظل الطرف الثاني مسؤولاً عن سداد جميع المستحقات, المستحقة للطرف الأول حتى تاريخ سحب الأعمال من الطرف الأول",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (35): FORCE MAJEURE:",
                description: "",
                sub_title:
                  "35.1. Neither Party shall be in violation of this Agreement or shall be otherwise legally liable towards the other Party due to any delay   in   the   performance   or   non-performance of any of the obligations of such party under this Agreement if such delay in performance or non-performance is due to a force majeure event.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "35.2. Upon the occurrence of any force majeure event, the Parties shall take all reasonable measures to limit the effect of such event.  The Parties shall be released from the performance    of these obligations throughout the duration of the force majeure event and shall be granted extension for a corresponding similar period.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "35.3. For the purposes of this clause, a “Force Majeure Event” includes, but is not limited to, acts of God, wars, earthquakes, storms, floods, other natural disasters, or other circumstances   beyond   the   Parties’ control,  provided  that  if  either  Party requests  an  extension  due  to  a  force majeure event, such Party shall prove to the other Party that: (1) an event of force majeure was not expected at the time of execution of this Agreement; (2) beyond the damaged Party’s control; (3) impedes the damaged Party’s performance of its obligations hereunder; and (4) may not be remedied.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "المادة (35) القوة القهرية :  ",
                description: "",
                sub_title:
                  "1.35. لا ينتهك أي من الطرفين هذه الاتفاقية أو سيكون مسؤولاً قانونيًا تجاه الطرف الآخر بسبب أي تأخير في أداء أو عدم أداء أي من التزامات هذا الطرف بموجب هذه الاتفاقية إذا يرجع هذا التأخير في الأداء أو عدم الأداء إلى حدث قوة قاهرة .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.35 عند حدوث أي حدث قوة قاهرة ، يجب على الأطراف اتخاذ جميع التدابير المعقولة للحد من تأثير هذا الحدث. يُعفى الأطراف من أداء هذه الالتزامات طوال مدة حدث القوة القاهرة ويمنحون تمديدًا لفترة مماثلة .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  '3.35. لأغراض هذا البند ، يشمل "حدث القوة القاهرة" ، على سبيل المثال لا الحصر ، القضاء والقدر أو الحروب أو الزلازل أو العواصف أو الفيضانات أو الكوارث الطبيعية الأخرى أو أي ظروف أخرى خارجة عن إرادة الأطراف ، شرطا أن يطلب الطرف تمديدًا بسبب حدث قوة قاهرة ، يجب على هذا الطرف أن يثبت للطرف الآخر أن: (1) حدث قوة قاهرة لم يكن متوقعًا في وقت تنفيذ هذه الاتفاقية ؛ (2) خارجة عن سيطرة الطرف المتضرر ؛ (3) يعيق أداء الطرف المتضرر لالتزاماته بموجب هذه الاتفاقية ؛ و (4) لا يجوز تداركه .',
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Article (36): Settlement of Disputes",
        description:
          "Any dispute arising out between the parties and it is not possible to amicably resolve it, shall be referred to the judicial competent authorities in the Kingdom. In all cases, the dispute taking place shall not prevent the obligation of the parties to continue the execution of the contract works.      ",
        sub: [
          {
            title: "",
            description: "",
            articles: [],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: " المادة  (36) : تسوية الخلافات",
        description:
          "يحال أي نزاع ينشأ بين الطرفين ولا يمكن حله وديًا إلى السلطات القضائية المختصة في المملكة. وفي جميع الأحوال لا يحول النزاع الدائر دون التزام الطرفين بمواصلة تنفيذ أعمال العقد .",
        sub: [
          {
            title: "",
            description: "",
            articles: [],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Article (37): Suspension of Service",
        description:
          "If the Second Party does not adhere to the Clauses of this Contract, the following actions would be initiated by the First Party,",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title:
                  "37.1. Written Notice – First Party will serve a written notice to the Second Party giving one week time for taking corrective actions against the points raised in the notice.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "37.2. Suspension – First Party will suspend the works and restrict the workers from attending the Project/ Site after completion of the written notice period.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "37.3. Termination – If no efforts are made by the Second party to take corrective action even after 10 days of suspension of the Project work, The First Party will have no option but to terminate the Contract. The Second Party will be liable to pay the First Party for all the charges mentioned in Clause 19 (4) and this would include the time period of the suspension of work leading to Termination of Contract due to the breach of the Contract Agreement.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: " المادة (37): وقف الخدمة",
        description:
          "إذا لم يلتزم الطرف الثاني ببنود هذا العقد ، فسيبدأ الطرف الأول الإجراءات التالية ،",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title:
                  "1.37. إشعار خطي - سيرسل الطرف الأول إشعارًا مكتوبًا إلى الطرف الثاني يمنحه مهلة أسبوع واحد لاتخاذ الإجراءات التصحيحية ضد النقاط التي كتبت في الإشعار ",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "2.37. التعليق - يوقف الطرف الأول الأعمال ويقيد حضور العمال للمشروع / الموقع بعد انتهاء فترة الإخطار الكتابي",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "3.37. الإنهاء - إذا لم يبذل الطرف الثاني أي جهود لاتخاذ إجراءات تصحيحية حتى بعد 10 أيام من تعليق عمل المشروع ، فلن يكون لدى الطرف الأول خيار سوى إنهاء العقد.سيكون الطرف الثاني مسؤولاً عن دفع الطرف الأول لجميع الرسوم المذكورة في البند 19 (4) وسيشمل ذلك الفترة الزمنية لتعليق العمل المؤدي إلى إنهاء العقد بسبب خرق اتفاقية العقد",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Article (38): Termination",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title:
                  "38. The First Party may immediately withdraw the Services and terminate this Contract:",
                lists: [
                  "1.  If the Second party fails to pay any sum that has become due and payable to the First Party by its due date whether the same has been formally demanded by the First Party. The Second party shall pay the First party final invoices within the Payment Terms set out in Annexure.",
                  "2.  If the Second Party subcontracts, loans, hire-out or seconds any Employee to a third party in KSA or",
                  "3.  If the Second party is the subject of an Insolvency Event.",
                ],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: " المادة (38): الإنهاء",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title:
                  "يجوز للطرف الأول سحب الخدمات فورًا وإنهاء هذا العقد:38",
                lists: [
                  "1. إذا لم يقم الطرف الثاني بدفع أي مبلغ أصبح مستحقاً وواجباً السداد للطرف الأول بحلول تاريخ استحقاقه سواء كان ذلك قد طالب به رسمياً من قبل الطرف الأول. يتعين على الطرف الثاني دفع الفواتير النهائية للطرف الأول ضمن شروط الدفع المنصوص عليها في الملحق .",
                  "2. إذا تعاقد الطرف الثاني من الباطن أو أقرض أو قام بتأجير أي موظف إلى طرف ثالث في المملكة العربية السعودية أو",
                  ". إذا كان الطرف الثاني موضوع حدوث إفلاس.3",
                ],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Article (39): Taxes and Fees",
        description:
          "Both parties shall be governed by the regulations of the Kingdom relating to taxes and fees. They shall pay the same on time and their amounts due to the competent authority. In case of amendment of taxes and fees, First Party has a right to adjust the costs during the period of Contract. If Saudi Arabian government fees change, The Second Party will be obliged (during the period of Contract) to pay the difference amount provided The First Party gives legitimate justification and proof of such to The Second Party. The adjustment shall be limited to the actual fees.",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "المادة (39): الضرائب والرسوم",
        description:
          "يخضع كلا الطرفين لأنظمة المملكة فيما يتعلق بالضرائب والرسوم. وعليهم أن يدفعوا نفس المبلغ في موعده والمبالغ المستحقة  للسلطة المختصة. في حالة تعديل الضرائب والرسوم ، يحق للطرف الأول تعديل التكاليف خلال فترة العقد. إذا تغيرت رسوم الحكومة السعودية ، فسيكون الطرف الثاني ملزمًا (خلال فترة العقد) بدفع مبلغ الفرق بشرط أن يقدم الطرف الأول تبريرًا شرعيًا وإثباتًا لذلك إلى  الطرف الثاني. يجب أن يقتصر التعديل على الرسوم الفعلية .",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Article (40): Serving of Notices",
        description:
          "The notices and notification concerning this contract shall be exchanged either by delivering them by hand against a receipt or through official or registered mail, electronic mail (e-mail) approved and mentioned at the beginning of the contract and shall be deemed to have been duly given or sent if delivered in the manner mentioned to any of the addresses indicated at the beginning of the contract.  The address may be changed by notifying the other party of its change.",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: " المادة (40) : تسليم الإخطارات",
        description:
          "يتم تبادل الإخطارات والإشعارات المتعلقة بهذا العقد إما عن طريق تسليمها باليد مقابل إيصال أو من خلال البريد الرسمي أو المسجل والبريد الإلكتروني (البريد الإلكتروني) المعتمد والمذكور في بداية العقد ويعتبر أنه قد تم حسب الأصول. يتم تقديمها أو إرسالها إذا تم تسليمها بالطريقة المذكورة إلى أي من العناوين الموضحة في بداية العقد يمكن تغيير العنوان بإخطار الطرف الآخر بتغييره ",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Article (41):",
        description:
          "No party shall be entitled to cancel its commercial registration until fulfillment of its entire obligations.",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "المادة (41):",
        description:
          "لا يحق لأي طرف إلغاء سجله التجاري إلا بعد وفائه بكامل التزامات",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "Article (42): Confidentiality",
        description:
          "Confidential information refers to all information and financial data and all data information in any medium of any kind, for any of the Parties which has been identified as Confidential or are inherently confidential or subject to the rights of ownership in general, regardless of whether the classification of such information and data in this capacity has been done or not. This includes all trades and financial information, and information of the both parties and affiliated Companies, including information relating to the business of the both Parties and the affiliated Companies, and financial information that has not been disclosed publicly by either of the Parties or its Clients or Vendors, as well as fiscal plans, marketing plans, schedules, accounts, correspondence, Agreements and documents.",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: " المادة (42): السرية",
        description:
          "تشير المعلومات السرية إلى جميع المعلومات والبيانات المالية وجميع معلومات البيانات في أي وسيط من أي نوع ، لأي من الأطراف التي تم تحديدها على أنها سرية أو سرية بطبيعتها أو تخضع لحقوق الملكية بشكل عام ، بغض النظر عما إذا كان التصنيف من هذه المعلومات والبيانات بهذه الصفة فعلت أم لا. يشمل ذلك جميع المعاملات والمعلومات المالية ، ومعلومات كلا الطرفين والشركات التابعة ، بما في ذلك المعلومات المتعلقة بأعمال كلا الطرفين والشركات التابعة ، والمعلومات المالية التي لم يتم الكشف عنها علنًا من قبل أي من الأطراف أو عملائها. أو البائعين ، وكذلك الخطط المالية وخطط التسويق والجداول والحسابات والمراسلات والاتفاقيات والوثائق .",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title: "",
                lists: [],
              },
            ],
          },
        ],
      },
    },
    {
      english: {
        centered_title: "",
        title: "",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "Article (43): Important Cautions:",
                description: "",
                sub_title:
                  "43.1. The First Party shall carry out the services as stated in the context hereof at the   specified locations within the agreed hours stated herein. And the First Party will issue permit from the AJEER system at the Ministry of Labor.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.2. The First Party shall be solely responsible for the acts and conduct of its personnel at the Second Party’s locations.  The Second Party shall not be liable for any damages resulting from the acts of the First Party’s personnel, unless such acts were carried out based on the Second Party’s instructions.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.3. The First Party undertakes and warrants that it will not herein rely on using or influencing the client’s file at Labor Office.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.4. In accordance with the Labor law, working days for Muslim workers will be reduced by two hours daily during the holy month of Ramadan.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.5. In accordance with the Labor law, all personnel shall be entitled to a paid holiday of (4) days on the occasion of Eid El Fitr, (4) days on the occasion of Eid Al Adha and (1) day for the Saudi National day.  The client agrees that these public holidays shall not be deducted from charge of the services rendered by the service provider.  ",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.6. The second party is obligated to secure all security and safety requirements, first aid and emergency cases, adhere to all professional safety requirements, and provide everything necessary for emergencies and first aid.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.7. The second party is obligated to insure its property, establishments and vehicles that are privatized, and the insurance is under the supervision and follow-up of the second party",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.8. The Second Party undertakes that it will not assign any task to any employee or worker of the First Party which is not permitted and authorized by the Law, or illegal or inhumane. If the Second Party is in violation of the above, any and all liabilities shall be fully borne by the Second Party.",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "43.9. The First Party is responsible for all social security payments for their workers subject to his leave, and it is fully responsible for work related injuries and death. The repatriation of the human remains to his country of origin is the responsibility of the First Party and the same will not be considered as a mandatory clause of the Contract. This contract includes all the clause agreement and is valid once they sign it, and the two parties fully acknowledge their legal capacity to sign the contract, and the contract is drawn up in two copies. Each party receives a copy to act accordingly.",
                lists: [],
              },
            ],
          },
        ],
      },
      arabic: {
        centered_title: "",
        title: "المادة (43): تنبيهات مهمة : ",
        description: "",
        sub: [
          {
            title: "",
            description: "",
            articles: [
              {
                title: "",
                description: "",
                sub_title:
                  ". 1.43. يتعين على الطرف الأول تنفيذ الخدمات كما هو مذكور في سياق هذه الوثيقة في المواقع المحددة خلال الساعات المتفق عليها والمذكورة هنا. وسيقوم الطرف الأول بإصدار تصريح من نظام وزارة العمل 'اجير' .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  ". 2.43 . يكون الطرف الأول مسؤولاً وحده عن أفعال وسلوك أفراده في مواقع الطرف الثاني. لن يكون الطرف الثاني مسؤولاً عن أي أضرار ناتجة عن أفعال موظفي الطرف الأول ، ما لم يتم تنفيذ هذه الأعمال بناءً على تعليمات الطرف الثاني .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "3.43. يتعهد الطرف الأول ويتعهد بأنه لن يعتمد في هذا المستند على استخدام أو التأثير على ملف العميل في مكتب العمل .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "4.43. وفقًا لقانون العمل ، سيتم تخفيض أيام العمل للعمال المسلمين بمقدار ساعتين يوميًا خلال شهر رمضان المبارك .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "5.43. وفقًا لقانون العمل ، يحق لجميع الموظفين الحصول على إجازة مدفوعة الأجر مدتها (4) أيام بمناسبة عيد الفطر ، و (4) أيام بمناسبة عيد الأضحى ، و (1) يوم لليوم الوطني السعودي. . يوافق العميل على عدم خصم هذه العطل الرسمية من تكلفة الخدمات المقدمة من قبل مزود الخدمة .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "6.43. يلتزم الطرف الثاني بتأمين كافة متطلبات الأمن والسلامة والإسعافات الأولية وحالات الطوارئ والالتزام بكافة متطلبات السلامة المهنية وتوفير كل ما يلزم لحالات الطوارئ والإسعافات الأولية .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "7.43.يلتزم الطرف الثاني بتأمين ممتلكاته ومنشآته ومركباته المخصصة ، ويكون التأمين بإشراف ومتابعة الطرف الثاني .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  "8.43. يتعهد الطرف الثاني بأنه لن يقوم بتعيين أي مهمة إلى أي موظف أو عامل تابع للطرف الأول غير مسموح به ومصرح به بموجب القانون ، أو غير قانوني أو غير إنساني. إذا كان الطرف الثاني ينتهك ما ورد أعلاه ، فإن أي وجميع الالتزامات يتحملها الطرف الثاني بالكامل .",
                lists: [],
              },
              {
                title: "",
                description: "",
                sub_title:
                  " 9.43. الطرف الأول مسؤول عن جميع مدفوعات الضمان الاجتماعي للعمال الخاضعين لإجازته ، وهو مسؤول مسؤولية كاملة عن إصابات العمل والوفاة. تقع مسؤولية إعادة الرفات البشرية إلى بلده الأصلي على عاتق الطرف الأول ولن يتم اعتبار ذلك كشرط إلزامي في العقد .يشتمل هذا العقد على جميع بنود الاتفاقية ويكون ساري المفعول بمجرد التوقيع عليه ، ويقر الطرفان تمامًا بأهليتهما القانونية لتوقيع العقد ، ويتم تحرير العقد من نسختين. يتلقى كل طرف نسخة للعمل وفقًا لذلك .",
                lists: [],
              },
            ],
          },
        ],
      },
    },
  ];
  console.log("contractDetails......contractpdf........", contractDetails);
  return (
    <Document>
      {/* <PageLayout pageNo={1} company={contractDetails?.visa_provider}> */}
      <PageLayout pageNo={1} company={contractDetails?.visa_provider}>
        <Text
          style={{
            textAlign: "center",
            marginTop: 10,
            fontSize: 14,
            fontFamily: "Helvetica-Bold",
          }}
        >
          SERVICE AGREEMENT
        </Text>

        <View style={{ marginTop: 20, fontSize: 10 }}>
          <View style={{ flexDirection: "row" }}>
            <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 1 }}>
              Contract Number:
            </Text>
            <Text>{Page1Data?.contract_number}</Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <Text style={{ fontFamily: "Helvetica-Bold" }}>
              Date of Contract:
            </Text>
            <Text>{Page1Data?.date_of_contract}</Text>
          </View>
        </View>
        <Text
          style={{
            marginTop: 15,
            fontSize: 10,
          }}
        >
          This Contract Agreement is made and entered by both Parties and
          executed by the legally authorized Persons of both Parties.
        </Text>

        <View style={{ border: 1, marginTop: 15, fontSize: 10 }}>
          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View style={{ borderRight: 1, padding: 5, width: "70%" }}>
              <Text>{Page1Data?.visa_provider}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "5%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>C.R.</Text>
            </View>

            <View style={{ padding: 5, width: "25%" }}>
              <Text>{Page1Data?.company_cr}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "10%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Address</Text>
            </View>

            <View style={{ padding: 5, width: "90%" }}>
              <Text>{Page1Data?.company_address}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "10%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>P.O. Box</Text>
            </View>

            <View style={{ borderRight: 1, padding: 5, width: "20%" }}>
              <Text>{Page1Data?.company_po_box}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "15%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Code</Text>
            </View>

            <View style={{ borderRight: 1, padding: 5, width: "20%" }}>
              <Text>{Page1Data?.company_code}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "15%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Mobile</Text>
            </View>

            <View style={{ padding: 5, width: "20%" }}>
              <Text>{Page1Data?.company_mobile}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "25%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Represented herein by Mr.</Text>
            </View>

            <View style={{ padding: 5, width: "75%" }}>
              <Text>{Page1Data?.company_signing_authority}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "25%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>National Identity No.</Text>
            </View>

            <View style={{ borderRight: 1, padding: 5, width: "15%" }}>
              <Text>{Page1Data?.company_nationalIdentity}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "25%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>E-mail</Text>
            </View>

            <View style={{ padding: 5, width: "35%" }}>
              <Text>{Page1Data?.company_email}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", backgroundColor: "#ddd" }}>
            <View
              style={{
                padding: 5,
                width: "100%",
                textAlign: "center",
                fontFamily: "Helvetica-Bold",
              }}
            >
              <Text>Referred to herein as "First Party"</Text>
            </View>
          </View>
        </View>

        <View style={{ border: 1, marginTop: 25, fontSize: 10 }}>
          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View style={{ borderRight: 1, padding: 5, width: "70%" }}>
              <Text>{Page1Data?.client_name}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "5%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>C.R.</Text>
            </View>

            <View style={{ padding: 5, width: "25%" }}>
              <Text>{Page1Data?.client_cr}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "10%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Address</Text>
            </View>

            <View style={{ padding: 5, width: "90%" }}>
              <Text>{Page1Data?.client_address}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "10%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>P.O. Box</Text>
            </View>

            <View style={{ borderRight: 1, padding: 5, width: "20%" }}>
              <Text>{Page1Data?.client_po_box}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "15%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Code</Text>
            </View>

            <View style={{ borderRight: 1, padding: 5, width: "20%" }}>
              <Text>{Page1Data?.client_code}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "15%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Mobile</Text>
            </View>

            <View style={{ padding: 5, width: "20%" }}>
              <Text>{Page1Data?.client_mobile}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "25%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>Represented herein by Mr.</Text>
            </View>

            <View style={{ padding: 5, width: "75%" }}>
              <Text>{Page1Data?.client_signing_authority}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", borderBottom: 1 }}>
            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "25%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>National Identity No.</Text>
            </View>

            <View style={{ borderRight: 1, padding: 5, width: "15%" }}>
              <Text>{Page1Data?.client_nationalIdentity}</Text>
            </View>

            <View
              style={{
                borderRight: 1,
                padding: 5,
                width: "25%",
                backgroundColor: "#ddd",
              }}
            >
              <Text>E-mail</Text>
            </View>

            <View style={{ padding: 5, width: "35%" }}>
              <Text>{Page1Data?.client_email}</Text>
            </View>
          </View>

          <View style={{ flexDirection: "row", backgroundColor: "#ddd" }}>
            <View
              style={{
                padding: 5,
                width: "100%",
                textAlign: "center",
                fontFamily: "Helvetica-Bold",
              }}
            >
              <Text>Referred to herein as "Second Party"</Text>
            </View>
          </View>
        </View>
      </PageLayout>

      <PageLayout pageNo={2} company={contractDetails?.visa_provider}>
        <View
          style={{
            borderTop: 1,
            height: 1,
            width: "100%",
          }}
          fixed
        ></View>

        <View style={{ border: 1, borderBottom: 0 }}>
          {Table3Data?.map((item, index) => (
            <View key={index} style={{ flexDirection: "row", borderBottom: 1 }}>
              <View style={{ borderRight: 1, width: "100%", padding: 5 }}>
                <Text
                  style={{
                    fontFamily: "Helvetica-Bold",
                    marginBottom: 1,
                    textAlign: "center",
                  }}
                >
                  {item?.english?.centered_title}
                </Text>
                <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 1 }}>
                  {item?.english?.title}
                </Text>
                <Text style={{ marginBottom: 1 }}>
                  {item?.english?.description}
                </Text>
                {item?.english?.sub?.map((sub, subindex) => (
                  <View key={subindex}>
                    <Text
                      style={{ fontFamily: "Helvetica-Bold", marginBottom: 1 }}
                    >
                      {sub?.title}
                    </Text>
                    <Text style={{ marginBottom: 1 }}>{sub?.description}</Text>
                    <Text
                      style={{
                        fontFamily: "Helvetica-Bold",
                        marginBottom: 1,
                        fontSize: 12,
                      }}
                    >
                      {sub?.account_number}
                    </Text>
                    {sub?.account_number ? (
                      <Image
                        style={{ marginBottom: 1, maxWidth: 100 }}
                        source={BankImage}
                      />
                    ) : (
                      <Text></Text>
                    )}

                    <Text
                      style={{
                        fontFamily: "Helvetica-Bold",
                        marginBottom: 1,
                        fontSize: 12,
                      }}
                    >
                      {sub?.vat_number}
                    </Text>
                    {sub?.vat_number ? (
                      <Image
                        style={{ marginBottom: 1, maxWidth: 100 }}
                        source={VatImage}
                      />
                    ) : (
                      <Text></Text>
                    )}
                    {sub?.articles?.map((article, artIndex) => (
                      <View key={artIndex}>
                        <Text
                          style={{
                            fontFamily: "Helvetica-Bold",
                            marginBottom: 2,
                          }}
                        >
                          {article?.title}
                        </Text>
                        <Text style={{ marginBottom: 1 }}>
                          {article?.description}
                        </Text>
                        <Text style={{ marginBottom: 2 }}>
                          {article?.sub_title}
                        </Text>
                        {article?.lists?.map((list, listindx) => (
                          <Text
                            style={{ marginLeft: 2, marginBottom: 1 }}
                            key={listindx}
                          >
                            <Text
                              style={{
                                fontFamily: "Helvetica-Bold",
                                marginHorizontal: 2,
                              }}
                            >
                              {" - "}
                            </Text>
                            <Text break>{list}</Text>
                          </Text>
                        ))}
                      </View>
                    ))}
                  </View>
                ))}
              </View>
              <View
                style={{
                  width: "100%",
                  padding: 5,
                  fontFamily: "Arabic",
                }}
              >
                {item?.arabic?.centered_title ? (
                  // <ArabicComponent
                  //   arabText={item?.arabic?.centered_title}
                  //   textStyle={{ fontFamily: "ArabicBold" }}
                  // />
                  <Text style={styles.arabicTextBold}>
                    {item?.arabic?.centered_title}
                  </Text>
                ) : (
                  <Text></Text>
                )}
                {item?.arabic?.title ? (
                  // <ArabicComponent
                  //   arabText={item?.arabic?.title}
                  //   textStyle={{ fontFamily: "ArabicBold" }}
                  // />
                  <Text style={styles.arabicTextBold}>
                    {item?.arabic?.title}
                  </Text>
                ) : (
                  <Text></Text>
                )}

                {item?.arabic?.description ? (
                  // <ArabicComponent arabText={item?.arabic?.description} />
                  <Text style={styles.arabicText}>
                    {item?.arabic?.description}
                  </Text>
                ) : (
                  <Text></Text>
                )}

                {item?.arabic?.sub?.map((sub, subindex) => (
                  <View
                    key={subindex}
                    style={{
                      width: "100%",
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    {sub?.title ? (
                      // <ArabicComponent
                      //   arabText={sub?.title}
                      //   textStyle={{ fontFamily: "ArabicBold" }}
                      // />
                      <Text style={styles.arabicTextBold}>{sub?.title}</Text>
                    ) : (
                      <Text></Text>
                    )}

                    {sub?.description ? (
                      // <ArabicComponent arabText={sub?.description} />
                      <Text style={styles.arabicText}>
                      {sub?.description}
                    </Text>
                    ) : (
                      <Text></Text>
                    )}

                    <Text
                      style={{
                        fontFamily: "Helvetica-Bold",
                        marginBottom: 1,
                        fontSize: 12,
                      }}
                    >
                      {sub?.account_number}
                    </Text>
                    {sub?.account_number ? (
                      <Image
                        style={{ marginBottom: 1, maxWidth: 100 }}
                        source={BankImage}
                      />
                    ) : (
                      <Text></Text>
                    )}

                    {/* <ArabicComponent arabText={sub?.vat_number} /> */}
                    <Text style={styles.arabicText}>{sub?.vat_number}</Text>
                    {sub?.vat_number ? (
                      <Image
                        style={{ marginBottom: 1, maxWidth: 100 }}
                        source={VatImage}
                      />
                    ) : (
                      <Text></Text>
                    )}

                    {sub?.articles?.length > 0 ? (
                      sub?.articles?.map((article, artIndex) => (
                        <View
                          style={{
                            marginVertical: index != 42 ? 10 : "",
                            marginBottom: index == 42 ? 25 : 10,
                          }}
                          key={artIndex}
                        >
                          {article?.title ? (
                            // <ArabicComponent
                            //   arabText={article?.title}
                            //   textStyle={{ fontFamily: "ArabicBold" }}
                            // />
                            <Text style={styles.arabicTextBold}>{article?.title}</Text>
                          ) : (
                            <Text></Text>
                          )}

                          {article?.description ? (
                            // <ArabicComponent arabText={article?.description} />
                            <Text style={styles.arabicText}>{article?.description}</Text>
                          ) : (
                            <Text></Text>
                          )}

                          {article?.sub_title ? (
                            // <ArabicComponent arabText={article?.sub_title} />
                            <Text style={styles.arabicText}>{article?.sub_title}</Text>
                          ) : (
                            <Text></Text>
                          )}
                          {article?.lists?.length > 0 ? (
                            article?.lists?.map((list, listindx) => (
                              <View
                                style={{
                                  width: "100%",
                                  flexDirection: "row",
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                                key={listindx}
                              >
                                {list ? (
                                  <>
                                    {/* <ArabicComponent arabText={list} /> */}
                                    <Text style={styles.arabicText}>{list}</Text>
                                    <Text
                                      style={{
                                        fontSize: 15,
                                        paddingRight: "10px",
                                      }}
                                      break
                                    >
                                      &#8226;
                                    </Text>
                                  </>
                                ) : (
                                  <Text></Text>
                                )}
                              </View>
                            ))
                          ) : (
                            <Text></Text>
                          )}
                        </View>
                      ))
                    ) : (
                      <Text></Text>
                    )}
                  </View>
                ))}
              </View>
            </View>
          ))}
        </View>

        <View
          style={{ borderBottom: 1, height: 1, width: "100%" }}
          fixed
        ></View>
        <View style={{ border: 1, marginTop: 20 }}>
          <View
            style={{
              borderBottom: 1,
              height: 30,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                fontSize: 12,
                padding: 1,
                textAlign: "center",
                fontFamily: "Helvetica-Bold",
              }}
            >
              ALLAH IS THE BESTOWER OF SUCCESS
            </Text>
          </View>
          <View style={{ flexDirection: "row", height: 30 }}>
            <Text
              style={{
                width: "50%",
                borderRight: 1,
                textAlign: "center",
                paddingTop: 3,
                fontFamily: "Helvetica-Bold",
              }}
            >
              {contractDetails?.visa_provider?.name}
            </Text>
            <Text
              style={{
                width: "50%",
                textAlign: "center",
                paddingTop: 3,
                fontFamily: "Helvetica-Bold",
              }}
            >
              {contractDetails?.client?.name}
            </Text>
          </View>
        </View>
        <View style={{ border: 1, width: "100%" }}>
          {tableData?.map((data, index) => (
            <View
              key={index}
              style={{
                width: "100%",
                height: data?.height || 30,
                borderBottom: 1,
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <View
                style={{
                  borderRight: 1,
                  width: "10%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Text style={{ paddingHorizontal: 2, paddingVertical: 3 }}>
                  {data?.col1}
                </Text>
              </View>
              <View
                style={{
                  borderRight: 1,
                  width: "40%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Text style={{ paddingHorizontal: 2, paddingVertical: 3 }}>
                  {data?.col2}
                </Text>
              </View>
              <View
                style={{
                  borderRight: 1,
                  width: "10%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Text style={{ paddingHorizontal: 2, paddingVertical: 3 }}>
                  {data?.col3}
                </Text>
              </View>
              <View
                style={{
                  borderRight: 1,
                  width: "40%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Text style={{ paddingHorizontal: 2, paddingVertical: 3 }}>
                  {data?.col4}
                </Text>
              </View>
            </View>
          ))}
        </View>
      </PageLayout>
    </Document>
  );
}
